import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What Quick Add still reads from the workspace: its open flag, query and keyboard highlight (driven by the workspace's Ctrl K and arrow-key handlers), and the create actions it starts.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmShellQuickAddHost = Pick<
  PmWorkspaceComponent,
  | 'activeQaIndex'
  | 'applyCustomLabels'
  | 'executeQuickAction'
  | 'getCustomLabel'
  | 'isQuickAddOpen'
  | 'quickAddQuery'
  | 'quickAddVisibleIndices'
  | 'stopProp'
>;

export const PM_SHELL_QUICK_ADD_HOST = new InjectionToken<PmShellQuickAddHost>('PmShellQuickAddHost');
